// extracted by mini-css-extract-plugin
export var container = "styles-module__container___XNMZV";
export var link = "styles-module__link___aZZJg";
export var outline = "styles-module__outline___SISbj";
export var text = "styles-module__text___zInqp";